import { EmptyState, PageHeader } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { RegisterDeviceForm } from '@/features/devices/RegisterDeviceForm';
import { useNavigate } from '@solidjs/router';
import { Show } from 'solid-js';

export default function RegisterDevicePage() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const canRegister = () => session()?.permissions.has('devices:register') ?? false;

  return (
    <section>
      <PageHeader title="Register device" />
      <div class="mx-auto max-w-6xl p-6">
        <Show
          when={canRegister()}
          fallback={
            <EmptyState
              variant="error"
              title="No permission"
              body="You don't have permission to register devices."
            />
          }
        >
          <div class="rounded-xl border border-neutral-100 bg-surface p-6 shadow-sm dark:border-neutral-800 dark:bg-surface-dark">
            <RegisterDeviceForm
              selfAssign="always"
              wide
              withPhotos
              onCancel={() => navigate('/devices/me')}
              onRegistered={() => navigate('/devices/me')}
              onClaimed={() => navigate('/devices/me')}
              onViewDevice={(deviceId) => navigate(`/devices/${deviceId}`)}
            />
          </div>
        </Show>
      </div>
    </section>
  );
}
